module.exports = __webpack_public_path__ + "media/images/of2-0e42b3665106db2429a111a81779eb87.jpg";